import { useState } from "react";
import DialogBox from '../LayoutComponents/Dialogbox.jsx';

export default function Setup({ gyroSettings, setGyroSettings }) {
    // 1. Add state to track if the info popup is open
    const [isInfoOpen, setIsInfoOpen] = useState(false);

    // 2. Create a handler function to open the popup
    const handleInfoClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsInfoOpen(true);
    };

    // 3. Swap the <a> tags for <span> tags in both text blocks
    const desktopText =  (
        <>
            Klicke auf die Punkte entlang der Strasse 
            <br />
            und erlebe die neuen Qualitäten dieses urbanen Grünraumes.
            <br />
            <br />
            <span onClick={handleInfoClick} style={{ textDecoration: 'underline', cursor: 'pointer', color: 'inherit' }}>Projekt Info</span>
        </>
    );

    const mobileText =  (
        <>
            Tippe auf die Punkte entlang der Strasse 
            <br />
            und erlebe die neuen Qualitäten 
            <br />
            dieses urbanen Grünraumes.
            <br />
            <br />
            5G<sup><img src="/images/ui/T_UI_5G.png" alt="5G" className="inline-icon" /></sup> empfohlen.
            <br />
            <span onClick={handleInfoClick} style={{ textDecoration: 'underline', cursor: 'pointer', color: 'inherit' }}>Projekt Info</span>
        </>
    );

    const isDesktop = /Windows NT|Macintosh|Linux/i.test(navigator.userAgent) && !/Android/i.test(navigator.userAgent);
    const isMobile = !isDesktop && (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || navigator.maxTouchPoints > 0);	
    const displayMessage = isMobile ? mobileText : desktopText;

    async function handleHotspotInteraction(sceneMedia) {
        let useGyro = false;
        if (isMobile) {
            if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
                try {
                    const permissionState = await DeviceOrientationEvent.requestPermission();
                    if (permissionState === 'granted') {
                        useGyro = true;
                    }
                } catch (error) {
                    console.error("Device orientation permission request denied or failed:", error);
                }
            } else {
                useGyro = true;
            }
        }

        setGyroSettings({
            useGyro: useGyro,
            permissionProcessed: true,
            initialSceneMedia: sceneMedia 
        });
    }

    return (
        <DialogBox
            text={displayMessage} 
            onHotspotClick={handleHotspotInteraction}
            // 4. Pass the state and setter as props to DialogBox
            isInfoOpen={isInfoOpen}
            setIsInfoOpen={setIsInfoOpen}
        />
    );
}